module.exports = __webpack_public_path__ + "img/minus.c43a07e5.svg";